webpackJsonp([70144966829960],{

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(44);
	
	var _reactLoadScript = __webpack_require__(176);
	
	var _reactLoadScript2 = _interopRequireDefault(_reactLoadScript);
	
	var _reactDom = __webpack_require__(27);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _graphql = __webpack_require__(50);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _reactHelmet = __webpack_require__(48);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactPage = function (_React$Component) {
	  _inherits(ContactPage, _React$Component);
	
	  function ContactPage() {
	    _classCallCheck(this, ContactPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ContactPage.prototype.render = function render() {
	    var thanks = 'http://localhost:8000/contact?success';
	    return _react2.default.createElement(
	      "section",
	      { className: "pv3 mv5 min-h" },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          "title",
	          null,
	          "Careful Not to Cry | Contact"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "fluid-width w-100 center mv5" },
	        this.props.location.search.includes('success') ? [_react2.default.createElement(
	          "h3",
	          { className: "lh-copy black f2 tc pt5 mt5 center" },
	          "Thanks for contacting us!"
	        ), _react2.default.createElement(
	          "p",
	          { className: "lh-copy black-50 f4 tc mt2" },
	          "We'll get back to you shortly"
	        )] : [_react2.default.createElement(
	          "div",
	          { className: "flex items-center content-center justify-center" },
	          _react2.default.createElement(
	            "h1",
	            { className: "lh-copy black f2 tc mt5 section-title dib center mb4" },
	            "Contact"
	          )
	        ), _react2.default.createElement(
	          "form",
	          { action: "https://formspree.io/eriksutch@gmail.com", method: "POST" },
	          _react2.default.createElement(
	            "div",
	            { className: "mv3" },
	            _react2.default.createElement("input", { className: "pa3 f4 br1 bn w-100 bg-black-10", type: "text", name: "name", placeholder: "Your Name" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "mv3" },
	            _react2.default.createElement("input", { className: "pa3 f4 br1 bn w-100 bg-black-10", type: "email", name: "_replyto", placeholder: "Your Email" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "mv3" },
	            _react2.default.createElement("textarea", { className: "pa3 f4 br1 bn w-100 bg-black-10 text-area", name: "message", placeholder: "Your Message" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "mv3" },
	            _react2.default.createElement("input", { type: "hidden", name: "_next", value: thanks }),
	            _react2.default.createElement("input", { className: "button blue-button bn center dib pointer", type: "submit", value: "Send" })
	          )
	        )]
	      )
	    );
	  };
	
	  return ContactPage;
	}(_react2.default.Component);
	
	exports.default = ContactPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-49282afe836cd7c20734.js